export { default } from './ScoredCardError'
